import angular from 'angular';

import ApplicationMessageController from './applicationMessageController';
import ApplicationResultsController from './applicationResultsController';
import CallInProductsController from './CallInProductsController';
import ProductAddedController from './productAddedController';


export default angular.module('app.appDetail.walkthrough.application', [])
    .controller('ApplicationMessageController', ApplicationMessageController)
    .controller('ApplicationResultsController', ApplicationResultsController)
    .controller('CallInProductsController', CallInProductsController)
    .controller('ProductAddedController', ProductAddedController)
    .run(($templateCache) => {
        $templateCache.put('app/appDetail/walkthrough/application/addProductsOnline.html', require('./addProductsOnline.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/application/applicationMessage.html', require('./applicationMessage.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/application/applicationResults.html', require('./applicationResults.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/application/callInProducts.html', require('./callInProducts.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/application/productAdded.html', require('./productAdded.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/application/productsSubmitted.html', require('./productsSubmitted.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/application/index.js